import 'animate.css';
import { reveal as Menu } from 'react-burger-menu';
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useEffect } from 'react';

import HomeChamada from './homeChamada';
import Swal from 'sweetalert2';

function Home(props) {

    const corPrincipal = '#dc494c';
    AOS.init();



    const urlParametros = new URLSearchParams(window.location.search);
    const parametro = urlParametros.get('i');

    const mensagem = (a = null) => {
        if (a !== null) {
            a.preventDefault();
        }
        Swal.fire({ title: 'Quase lá !', html: '<p>Relaxa, você não fez nada de errado.</p><br/><p>Acontece que o site ainda não está pronto. Estamos desenvolvendo ele dia após dia. Oque você vê aqui é apenas uma demostração visual de como a página principal do site ficará. Logo botões e as demais ações estão desabilitadas.</p>', icon: 'info' }).then(() => {
            Swal.fire({ title: 'Fique por dentro :)', html: "<p>Em nossas redes sociais você saberá certinho como está sendo todo o processo de desenvolvimento do seu Bar preferido (Taldo's Bar) com videos e etc.</p><br /><p>Eai, vem ficar pertinho da gente !!! </p><a style='color:blue;text-decoration:underline' href='" + window.location.origin + "'>Clique aqui</a>", icon: 'info' })
        })
    }

    const menuClick = () => {
        document.querySelector('.bm-overlay').click();
        setTimeout(() => {
            mensagem();
        }, 500)
    }



    useEffect(() => {
        if (parametro != null) scrollTo(parametro);
    }, [parametro])


    useEffect(() => {

        setTimeout(() => {
            document.querySelectorAll('.chamada-1-box-single')[0].classList.add('animate__bounceIn');
            document.querySelectorAll('.chamada-1-box-single')[4].classList.add('animate__bounceIn');
        }, 1000)

        setTimeout(() => {
            document.querySelectorAll('.chamada-1-box-single')[1].classList.add('animate__bounceIn');
            document.querySelectorAll('.chamada-1-box-single')[5].classList.add('animate__bounceIn');
        }, 2000)

        setTimeout(() => {
            document.querySelectorAll('.chamada-1-box-single')[2].classList.add('animate__bounceIn');
            document.querySelectorAll('.chamada-1-box-single')[6].classList.add('animate__bounceIn');
        }, 3000)

        setTimeout(() => {
            document.querySelectorAll('.chamada-1-box-single')[3].classList.add('animate__bounceIn');
            document.querySelectorAll('.chamada-1-box-single')[7].classList.add('animate__bounceIn');
        }, 4000)

        setTimeout(() => {
            document.querySelector('.end-chamada-1').classList.add('animate__flipInX');
        }, 5000)
    }, [])

    const scrollTo = (where) => {
        scroller.scrollTo(where, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    }

    return (
        <div id="outer-container">
            <Menu pageWrapId={"page-wrap"} outerContainerId={"outer-container"}>
                <Link className="menu-item" onClick={() => menuClick()} to="">Login</Link>
                <Link className="menu-item" onClick={() => menuClick()} to="">Registre-se</Link>
                <a className='menu-item' href="https://apoia.se/taldobars">Nos Apoie</a>
                <Link className="menu-item" onClick={() => menuClick()} to="">Ajuda</Link>
                <a className='menu-item' href="https://discord.gg/acMgWMDeBC">Discord</a>
            </Menu>
            <div style={{ color: corPrincipal }} id="page-wrap">
                <HomeChamada />
            </div>
        </div>
    );
}

export default Home;
